import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors, setSystemFormButtonSave, setNameValidationErrors } from '../../action/system'
import { getForeignSubErrors, parseNameValidationErrors } from '../../../helper/nameValidationErrors'
import storeMenu from '../../axios/product/menu/store'
import updateMenu from '../../axios/product/menu/put'
import { setProductsUpdateProduct } from '../../action/product'
import { resetSystemFormButtonSaveThunk, succeedSystemFormButtonSaveThunk } from '../app'
import { deleteProductImageThunk, getProductImageConfigThunk } from '../product'
import fetchCompanyData from '../../axios/registration/companyData'
import { setCompanyData } from '../../action/company'

export const storeMenuThunk = (data, callbackSuccess) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	dispatch(setNameValidationErrors({}))

	return storeMenu(data)
		.then((res) => {
			dispatch(succeedSystemFormButtonSaveThunk())
			if (typeof callbackSuccess === 'function') callbackSuccess()
			if (data.imgConditionsConfirmed) {
				dispatch(getProductImageConfigThunk(res.data.remoteResponse.id))
			}
		}).catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			const nameErrors = parseNameValidationErrors(error)
			if (nameErrors) {
				dispatch(setNameValidationErrors(nameErrors))
				const foreignSubErrors = getForeignSubErrors(error)
				if (foreignSubErrors.length) dispatch(setAppErrors(foreignSubErrors))
				return
			}
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateMenuThunk = (menuId, data, menuImageUploadStep, menuImageStatus) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	dispatch(setNameValidationErrors({}))

	return updateMenu(menuId, data)
		.then((res) => {
			dispatch(succeedSystemFormButtonSaveThunk())
			if (data.imgConditionsConfirmed && menuImageUploadStep === 'NOT_SAVED') {
				dispatch(getProductImageConfigThunk(menuId))
			}
			else if ((menuImageStatus === 'REJECTED' || menuImageStatus === 'APPROVED') && menuImageUploadStep === 'DEFAULT') {
				dispatch(deleteProductImageThunk(menuId))
			}
			return dispatch(setProductsUpdateProduct(res.data))
		}).catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			const nameErrors = parseNameValidationErrors(error)
			if (nameErrors) {
				dispatch(setNameValidationErrors(nameErrors))
				const foreignSubErrors = getForeignSubErrors(error)
				if (foreignSubErrors.length) dispatch(setAppErrors(foreignSubErrors))
				return
			}
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}


export const getCompanyDataThunk = (index) => dispatch => {
	return fetchCompanyData(index)
		.then(res => {
			dispatch(setCompanyData(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateMenuDataThunk = (menuId, data) => dispatch => {
	return updateMenu(menuId, data)
		.then((res) => {
			return dispatch(setProductsUpdateProduct(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
